(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5262],{

/***/ 77909:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ships/[id]",
      function () {
        return __webpack_require__(66685);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/Accordion/accordion.module.sass
var accordion_module = __webpack_require__(38264);
var accordion_module_default = /*#__PURE__*/__webpack_require__.n(accordion_module);
;// CONCATENATED MODULE: ./components/Accordion/Accordion.jsx




var Accordion = function(param) {
    var key = param.key, children = param.children, title = param.title, isOpen = param.isOpen, onCloseExModal = param.onCloseExModal, actionOnClick = param.actionOnClick;
    var ref = (0,react.useState)(isOpen), isActive = ref[0], setIsActive = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (accordion_module_default()).accordion,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "accordion-item",
            itemScope: true,
            itemProp: "mainEntity",
            itemType: "https://schema.org/Question",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: (accordion_module_default()).accordionTitle,
                    onClick: function() {
                        setIsActive(!isActive);
                        if (onCloseExModal) {
                            onCloseExModal();
                        }
                        if (actionOnClick) {
                            actionOnClick();
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (accordion_module_default()).innerTitle,
                            itemProp: "name",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: isActive ? (accordion_module_default()).open : (accordion_module_default()).close
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,classcat/* default */.Z)([
                        (accordion_module_default()).accordionContent,
                        isActive && (accordion_module_default()).accordionContentActive, 
                    ]),
                    itemScope: true,
                    itemProp: "acceptedAnswer",
                    itemType: "https://schema.org/Answer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        itemProp: "text",
                        children: children
                    })
                })
            ]
        })
    }, key);
};

;// CONCATENATED MODULE: ./components/Accordion/index.js



/***/ }),

/***/ 21110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* reexport */ Avatar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Avatar/avatar.module.sass
var avatar_module = __webpack_require__(16886);
var avatar_module_default = /*#__PURE__*/__webpack_require__.n(avatar_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/Avatar/Avatar.jsx








// import avatar from '../../public/icons/avatar.svg';
var Avatar = function(_param) /*#__PURE__*/ {
    var name = _param.name, userPick = _param.userPick, urlBF = _param.urlBF, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "userPick",
        "urlBF"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (avatar_module_default()).avatar
    }, props), {
        children: !name ? // <img className={styles.avatarImg} src={userPick || avatar} alt={name} />
        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (avatar_module_default()).avatarImg,
            children: userPick || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: urlBF === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                    name: "common/avatarBf",
                    width: 40,
                    height: 40
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                    name: "common/avatar",
                    width: 40,
                    height: 40
                })
            })
        }) : // <img
        //   className={styles.avatarImg}
        //   src={ userPick || <AvatarImg />}
        //   alt={name}
        // />
        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (avatar_module_default()).avatarName,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                variant: "linkAsButtonPrimarySm",
                transform: "uppercase",
                children: name
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/Avatar/index.js



/***/ }),

/***/ 63145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ Collapsed; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var esm = __webpack_require__(63108);
// EXTERNAL MODULE: ./components/Accordion/index.js + 1 modules
var Accordion = __webpack_require__(59166);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
;// CONCATENATED MODULE: ./components/Collapsed/Collapsed.jsx









/**
 * Компонент для скрытия контента
 * Переписать на нормальный компонент
 */ var Collapsed = function(_param) {
    var items = _param.items, isOpen = _param.isOpen, shorter = _param.shorter, isResult = _param.isResult, isCruis = _param.isCruis, isSeo = _param.isSeo, seo = _param.seo, isPickCaute = _param.isPickCaute, onCloseExModal = _param.onCloseExModal, onClickAction = _param.onClickAction, targets = _param.targets, props = (0,_object_without_properties/* default */.Z)(_param, [
        "items",
        "isOpen",
        "shorter",
        "isResult",
        "isCruis",
        "isSeo",
        "seo",
        "isPickCaute",
        "onCloseExModal",
        "onClickAction",
        "targets"
    ]);
    var ref;
    var ref1 = (0,react.useState)(3), count = ref1[0], setCount = ref1[1];
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isSeo && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: seo.map(function(param) {
                    var title = param.title, description = param.description;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isOpen: isOpen,
                        title: title
                    }, props), {
                        children: description
                    }));
                })
            }),
            isResult ? items === null || items === void 0 ? void 0 : items.map(function(i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isOpen: isOpen,
                    title: i.title
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                        content: "".concat(i.body.text)
                    })
                }), i.title);
            }).slice(0, shorter ? count : items.length) : (ref2 = (ref = items === null || items === void 0 ? void 0 : items.slice(0, shorter ? count : items.length)) === null || ref === void 0 ? void 0 : ref.map(function(i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isOpen: isOpen,
                    title: isSeo ? i === null || i === void 0 ? void 0 : i.caption : i === null || i === void 0 ? void 0 : i.title,
                    onCloseExModal: onCloseExModal,
                    actionOnClick: function() {
                        if (i.target) {
                            (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)([
                                i.target
                            ]);
                        }
                    }
                }, props), {
                    children: !isCruis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                        content: "".concat(!isPickCaute ? i.body : i === null || i === void 0 ? void 0 : i.desc)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: i.body
                    })
                }), i === null || i === void 0 ? void 0 : i.title);
            })) !== null && ref2 !== void 0 ? ref2 : [].slice(0, shorter ? count : items.length),
            shorter && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: count < (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setCount(count + 3);
                        (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)(onClickAction);
                    },
                    children: "Загрузить ещё вопросы"
                })
            })
        ]
    });
};
Collapsed.defaultProps = {
    isOpen: false,
    shorter: false
};

;// CONCATENATED MODULE: ./components/Collapsed/index.js



/***/ }),

/***/ 26167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* reexport */ Comment; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pure-react-carousel/dist/index.es.js
var index_es = __webpack_require__(28777);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var esm = __webpack_require__(63108);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./node_modules/simple-react-lightbox/dist/index.es.js
var dist_index_es = __webpack_require__(34930);
// EXTERNAL MODULE: ./components/Comment/comment.module.sass
var comment_module = __webpack_require__(63643);
var comment_module_default = /*#__PURE__*/__webpack_require__.n(comment_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/Avatar/index.js + 1 modules
var Avatar = __webpack_require__(21110);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
;// CONCATENATED MODULE: ./components/Comment/Comment.jsx













var options = {
    buttons: {
        showThumbnailsButton: false,
        showAutoplayButton: false,
        showFullscreenButton: true
    },
    thumbnails: {
        showThumbnails: false
    }
};
var Comment = function(_param) {
    var key = _param.key, inicials = _param.inicials, name = _param.name, date = _param.date, children = _param.children, liketext = _param.liketext, disliketext = _param.disliketext, reviewPhoto = _param.reviewPhoto, userPick = _param.userPick, ship = _param.ship, link = _param.link, stars = _param.stars, starShip = _param.starShip, isMobile = _param.isMobile, isModal = _param.isModal, props = (0,_object_without_properties/* default */.Z)(_param, [
        "key",
        "inicials",
        "name",
        "date",
        "children",
        "liketext",
        "disliketext",
        "reviewPhoto",
        "userPick",
        "ship",
        "link",
        "stars",
        "starShip",
        "isMobile",
        "isModal"
    ]);
    var ref = (0,react.useState)(false), showExcDescription = ref[0], setShowExcDescription = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (comment_module_default()).wrapper
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (comment_module_default()).allInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (comment_module_default()).info,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                className: (comment_module_default()).avatar,
                                name: inicials,
                                userPick: userPick
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (comment_module_default()).user,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                        children: date
                                    })
                                ]
                            })
                        ]
                    }),
                    !isModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (comment_module_default()).rating,
                        children: ship && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (comment_module_default()).link,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                    href: "/ships/".concat(link),
                                    variant: "reviewHref",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (comment_module_default()).star,
                                        children: [
                                            "".concat(ship, " ").concat(starShip > 0 ? "".concat(starShip) : ""),
                                            starShip > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/starBlue.svg",
                                                className: (comment_module_default()).star,
                                                alt: "звезда"
                                            })
                                        ]
                                    })
                                }),
                                " "
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classcat/* default */.Z)([
                    showExcDescription ? [] : [
                        (comment_module_default()).excClipper
                    ]
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                    content: "".concat(children)
                })
            }, key),
            isMobile ? children.length > 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (comment_module_default()).buttonClipper,
                children: !showExcDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setShowExcDescription(!showExcDescription);
                    },
                    view: "reviewsButton",
                    children: "Читать далее"
                }, key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setShowExcDescription(!showExcDescription);
                    },
                    view: "reviewsButton",
                    children: "Свернуть отзыв"
                }, key)
            }) : children.length > 300 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (comment_module_default()).buttonClipper,
                children: !showExcDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setShowExcDescription(!showExcDescription);
                    },
                    view: "reviewsButton",
                    children: "Читать далее"
                }, key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setShowExcDescription(!showExcDescription);
                    },
                    view: "reviewsButton",
                    children: "Свернуть отзыв"
                }, key)
            }),
            reviewPhoto && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* default */.ZP, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* SRLWrapper */.Iv, {
                    options: options,
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CarouselProvider */.sj, {
                            totalSlides: reviewPhoto && reviewPhoto.length,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (comment_module_default()).imgAll,
                                children: [
                                    reviewPhoto.map(function(i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (comment_module_default()).img,
                                            src: "/images/reviews/".concat(i),
                                            alt: "фото туристов"
                                        });
                                    }),
                                    " "
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/Comment/index.js



/***/ }),

/***/ 86318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ PrevArrow; },
/* harmony export */   "Ci": function() { return /* binding */ PrevThumbArrow; },
/* harmony export */   "gV": function() { return /* binding */ NextArrow; },
/* harmony export */   "s6": function() { return /* binding */ NextThumbArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classcat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83840);
/* harmony import */ var _arrows_module_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99407);
/* harmony import */ var _arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85708);
/* harmony import */ var _SpriteSVG__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2708);






var PrevArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonPrev)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-arrow",
                width: 16,
                height: 29
            })
        })
    });
};
var NextArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonNext)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-arrow",
                width: 16,
                height: 29,
                alt: "К следующему"
            }),
            title: "К следующему"
        })
    });
};
var PrevThumbArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonPrev)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            className: (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().lg),
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-thumb-arrow",
                width: 9,
                height: 17,
                alt: "К следующему"
            }),
            title: "К следующему"
        })
    });
};
var NextThumbArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonNext)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            className: (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().lg),
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-thumb-arrow",
                width: 9,
                height: 17,
                alt: "К следующему"
            }),
            title: "К следующему"
        })
    });
};


/***/ }),

/***/ 22334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Reviews; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-if/dist/react-if.esm.js
var react_if_esm = __webpack_require__(34394);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./components/Comment/index.js + 1 modules
var Comment = __webpack_require__(26167);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./hooks/useLimitList.js
var useLimitList = __webpack_require__(99905);
// EXTERNAL MODULE: ./components/Reviews/reviews.module.sass
var reviews_module = __webpack_require__(69907);
var reviews_module_default = /*#__PURE__*/__webpack_require__.n(reviews_module);
;// CONCATENATED MODULE: ./components/Reviews/Reviews.jsx









var Reviews = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, link = param.link, _limit = param.limit, limit = _limit === void 0 ? 3 : _limit, noButton = param.noButton, clipp = param.clipp, setClipp = param.setClipp, isMobile = param.isMobile, isModal = param.isModal, metriks = param.metriks;
    var ref = (0,useLimitList/* useLimitList */.U)({
        count: items.length,
        limit: limit
    }), show = ref.show, isCanShowMore = ref.isCanShowMore, onShowMore = ref.onShowMore;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            items.length > 0 && (limit ? items.slice(0, show) : items).map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comment/* Comment */.s, {
                    userPick: item.user_img && "".concat("https://kruiz.online", "/").concat(item.user_img),
                    name: item.username,
                    date: dayjs_min_default()(item.r_date).format("DD MMMM YYYY"),
                    link: item.url,
                    ship: item.t_title,
                    stars: item.raiting_company,
                    starShip: item.raiting_ship,
                    reviewPhoto: item.fotos,
                    clipp: clipp,
                    setClipp: setClipp,
                    isMobile: isMobile,
                    isModal: isModal,
                    children: item.review
                }, index);
            }),
            !noButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm.If, {
                condition: !link,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                        children: isCanShowMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: "lg",
                            onClick: function() {
                                onShowMore();
                                window.ym(35441960, "reachGoal", metriks);
                            // YaAndGaCruisePage(onClickAction);
                            // YaAndGaShipPage(onActionClick);
                            },
                            fullWidth: true,
                            children: "Загрузить ещё отзывы"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Else */.Ot, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (reviews_module_default()).infoWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (reviews_module_default()).info,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                    className: (reviews_module_default()).button,
                                    href: link,
                                    variant: "linkAsbutton2",
                                    onClick: function() {
                                        window.ym(35441960, "reachGoal", metriks);
                                    },
                                    children: "Загрузить ещё отзывы"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Reviews/index.js



/***/ }),

/***/ 11711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useHiddenWithCookie; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_2__);



var useHiddenWithCookie = function(func) {
    var getCookie = (0,nookies__WEBPACK_IMPORTED_MODULE_2__.parseCookies)();
    var currentDate = dayjs__WEBPACK_IMPORTED_MODULE_1___default()();
    var timeEnd = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(getCookie === null || getCookie === void 0 ? void 0 : getCookie.timeToOpenBanner);
    var timeToOpen = timeEnd <= currentDate;
    // eslint-disable-next-line consistent-return
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (timeToOpen) {
            func();
        }
    }, []);
};


/***/ }),

/***/ 99905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useLimitList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useLimitList = function(param) {
    var count = param.count, _limit = param.limit, limit = _limit === void 0 ? 3 : _limit;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(limit), show = ref[0], setShow = ref[1];
    var onShowMore = function() {
        setShow(show + limit);
    };
    return {
        show: show,
        onShowMore: onShowMore,
        isCanShowMore: count > limit && count > show
    };
};


/***/ }),

/***/ 66685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Ship; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-useragent/dist/next-useragent.js
var next_useragent = __webpack_require__(28010);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
// EXTERNAL MODULE: ./components/Features/index.js + 1 modules
var Features = __webpack_require__(15944);
// EXTERNAL MODULE: ./components/Collapsed/index.js + 1 modules
var Collapsed = __webpack_require__(63145);
// EXTERNAL MODULE: ./components/Layout/index.js + 6 modules
var Layout = __webpack_require__(82913);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./components/Card/index.js + 3 modules
var Card = __webpack_require__(23215);
// EXTERNAL MODULE: ./utils/declOfNum.js
var declOfNum = __webpack_require__(5547);
// EXTERNAL MODULE: ./components/ShipsPage/FilterShips/index.js + 2 modules
var FilterShips = __webpack_require__(53089);
// EXTERNAL MODULE: ./utils/seo.js
var utils_seo = __webpack_require__(13553);
// EXTERNAL MODULE: ./utils/serialize.jsx
var serialize = __webpack_require__(27777);
// EXTERNAL MODULE: ./components/Reviews/index.js + 1 modules
var Reviews = __webpack_require__(22334);
// EXTERNAL MODULE: ./utils/scrollToUtil.js
var scrollToUtil = __webpack_require__(17740);
// EXTERNAL MODULE: ./components/CruisePageComponents/PricePanel/index.js + 2 modules
var PricePanel = __webpack_require__(96705);
// EXTERNAL MODULE: ./styles/shipPage.module.sass
var shipPage_module = __webpack_require__(51505);
var shipPage_module_default = /*#__PURE__*/__webpack_require__.n(shipPage_module);
// EXTERNAL MODULE: ./components/Badge/index.js + 1 modules
var Badge = __webpack_require__(92558);
// EXTERNAL MODULE: ./providers/SearchStoreProvider.tsx + 5 modules
var SearchStoreProvider = __webpack_require__(27101);
// EXTERNAL MODULE: ./components/CruisePageComponents/MainGallery/index.js + 6 modules
var MainGallery = __webpack_require__(98796);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/ShipInfo/ShipInfo.jsx






// import SeatCountIco from '../../public/icons/seat_count.svg';
// import CauteCountIco from '../../public/icons/caute_count.svg';



var ShipInfo = function(param) {
    var years = param.years, caute = param.caute, seat = param.seat, description = param.description, shipType = param.shipType, shipHar = param.shipHar, setClipp = param.setClipp, clipp = param.clipp, construction = param.construction, shipTypeInfo = param.shipTypeInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shipPage_module_default()).restavration,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipPage_module_default()).restavrationText,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                variant: "heading-7",
                                className: (shipPage_module_default()).restavrationText,
                                children: "Модернизация"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (shipPage_module_default()).specificationsOneInside,
                                children: [
                                    years,
                                    " год"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipPage_module_default()).specificationsOne,
                        children: [
                            "Постройка",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shipPage_module_default()).specificationsOneInside,
                                children: [
                                    construction,
                                    " год"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shipPage_module_default()).count,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipPage_module_default()).countInfo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                    name: "promo/caute_count",
                                    width: 24,
                                    height: 24
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: (shipPage_module_default()).countInfoText,
                                children: "Общее количество кают"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: (shipPage_module_default()).countInfoText,
                                variant: "vosclic",
                                children: caute
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipPage_module_default()).countInfo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                    name: "promo/seat_count",
                                    width: 24,
                                    height: 24
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: (shipPage_module_default()).countInfoText,
                                children: "Вместимость (человек)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: (shipPage_module_default()).countInfoText,
                                variant: "vosclic",
                                children: seat
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: !clipp ? (shipPage_module_default()).shipDesc : (shipPage_module_default()).shipDescOff,
                children: description || description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: !clipp ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                    onClick: function() {
                        setClipp(true);
                    // if (shipType !== 'sea')
                    //   YaAndGaShipPage('click_open_description_ship');
                    },
                    children: [
                        "Открыть описание ",
                        shipTypeInfo
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                    onClick: function() {
                        setClipp(false);
                        if (shipType !== "sea") (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_h_description_shipide");
                    },
                    children: [
                        "Скрыть описание ",
                        shipTypeInfo
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shipPage_module_default()).specification,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        variant: "heading-7",
                        children: [
                            "Характеристики ",
                            shipType === "sea" ? "лайнера" : "теплохода"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipPage_module_default()).specifications,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shipPage_module_default()).specificationsOne,
                                children: [
                                    "Длина",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shipPage_module_default()).specificationsOneInside,
                                        children: [
                                            shipHar[0],
                                            " м."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shipPage_module_default()).specificationsOne,
                                children: [
                                    "Ширина",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shipPage_module_default()).specificationsOneInside,
                                        children: [
                                            shipHar[1],
                                            " м."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shipPage_module_default()).specificationsOne,
                                children: [
                                    "Осадка",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shipPage_module_default()).specificationsOneInside,
                                        children: [
                                            shipHar[2],
                                            " м."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ShipInfo/index.js


// EXTERNAL MODULE: ./components/YandexLink/index.js + 1 modules
var YandexLink = __webpack_require__(30988);
// EXTERNAL MODULE: ./components/BreadCrumbs/index.js + 1 modules
var BreadCrumbs = __webpack_require__(24277);
// EXTERNAL MODULE: ./components/ModalReload/index.js + 1 modules
var ModalReload = __webpack_require__(72581);
// EXTERNAL MODULE: ./lib/yandexDataLayer.js
var yandexDataLayer = __webpack_require__(12406);
// EXTERNAL MODULE: ./hooks/useHiddenWithCookie.js
var useHiddenWithCookie = __webpack_require__(11711);
// EXTERNAL MODULE: ./lib/sendVKPixelEvent.js
var sendVKPixelEvent = __webpack_require__(13866);
;// CONCATENATED MODULE: ./pages/ships/[id].jsx



































var BannerTop = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9422).then(__webpack_require__.bind(__webpack_require__, 9422)).then(function(mod) {
        return mod.CookieBanner;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9422)
            ];
        }
    }
});
var __N_SSP = true;
function Ship(param) {
    var uaString = param.uaString, drawInfo = param.drawInfo, drawCruise = param.drawCruise, seo = param.seo, _store = param.store, user = _store.user, cookies = _store.cookies, popularPopdirs = _store.popularPopdirs, canonicalUrl = param.canonicalUrl;
    var ua = (0,next_useragent/* useUserAgent */.FS)(uaString || window.navigator.userAgent);
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    var isSea = (drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.ship_direction) === "sea";
    var shipDetails = {
        id: drawInfo.id,
        name: drawInfo.t_title,
        brand: drawInfo.company,
        category: "".concat(drawInfo.ship_direction === "sea" ? "Море" : "Река", "/").concat(drawInfo.category_name, "/").concat(drawInfo.t_title),
        price: drawInfo.kr_min_price,
        quantity: 1
    };
    (0,react.useEffect)(function() {
        var ref, ref1;
        // Яндекс метрика - информация о пользователи и типе страницы
        (0,yandexDataLayer/* yandexUserLayer */.p$)(user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.id, user === null || user === void 0 ? void 0 : (ref1 = user.user) === null || ref1 === void 0 ? void 0 : ref1.group, isSea);
        (0,YaAndGaHelper/* YaAndGaShipPage */.tj)(isSea ? "isSeaPage" : "isRiverPage");
    }, [
        isSea
    ]);
    (0,react.useEffect)(function() {
        (0,yandexDataLayer/* yandexDataLayer */.qu)("detail", shipDetails);
        (0,sendVKPixelEvent/* sendVKPixelEvent */.c)("viewProduct", {
            product_id: drawInfo.id,
            value: drawInfo.kr_min_price
        });
    }, []);
    var shipsInfoTitle = (drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.id) === 410 || (drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.id) === 469 || (drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.id) === 468 ? 410 : isSea;
    var shipType = function(nameType, isRouter) {
        switch(nameType, isRouter){
            case nameType === 410 && "isTitle":
                return "Яхта";
            case nameType === 410 && "isRouter":
                return "яхте";
            case nameType === 410 && "isButton":
                return "яхты";
            case nameType === true && "isTitleSeo":
                return "лайнер";
            case nameType === true && "isTitle":
                return "Лайнер";
            case nameType === true && "isRouter":
                return "лайнере";
            case nameType === true && "isButton":
                return "лайнера";
            case nameType === false && "isTitle":
                return "Теплоход";
            case nameType === false && "isRouter":
                return "теплоходе";
            case nameType === false && "isButton":
                return "теплохода";
            default:
                return nameType;
        }
    };
    var arrayYear = drawInfo.navigation_years;
    Object.freeze(arrayYear);
    var tabsYear = arrayYear.map(function(i) {
        return {
            title: "Круизы на ".concat(i, " год"),
            value: i
        };
    });
    var ref = (0,react.useState)(), clipp = ref[0], setClipp = ref[1];
    var minPrice = isSea ? drawInfo.kr_min_price : drawInfo.kr_min_price_discounted;
    var meta = {
        title: "".concat(shipType(shipsInfoTitle, "isTitle"), " ").concat(seo.t_title, " – навигация  ").concat(drawInfo.year, ", расписание и цены круизов, отзывы туристов, фото кают и палубы"),
        description: "Выберете для себя круиз на теплоходе ".concat(seo.t_title, " в навигации ").concat(drawInfo.year, ": актуальное расписание и цены, реальные отзывы туристов, подробные фото кают и палуб. Идеальное сочетание комфорта и увлекательных маршрутов для незабываемого отдыха на воде. +7 495 877-58-34.")
    };
    var seaMeta = {
        title: "Круизный ".concat(shipType(shipsInfoTitle, "isTitleSeo"), " ").concat(seo.t_title, " – морские круизы ").concat(drawInfo.year),
        description: "Морские круизы на лайнере ".concat(seo.t_title, " купить онлайн по цене от ").concat(minPrice, " рублей. Узнать цены и скидки на навигацию ").concat(drawInfo.year, ", посмотреть расписание, фото и отзывы, услуги на борту, выбрать каюту и забронировать круиз онлайн или по тел: +7 499 643-57-40.\n")
    };
    var seoDataTitle = isSea ? seaMeta.title : meta.title;
    var seoDataDesc = isSea ? seaMeta.description : meta.description;
    var classCategoryReady;
    if (drawInfo.category_name === "Люкс") {
        classCategoryReady = "lux";
    } else if (drawInfo.category_name === "Комфорт") {
        classCategoryReady = "comfort";
    } else if (drawInfo.category_name === "Стандарт") {
        classCategoryReady = "standart";
    } else if (drawInfo.category_name === "Эконом") {
        classCategoryReady = "eco";
    } else if (drawInfo.category_name === "Премиум") {
        classCategoryReady = "premium";
    }
    // const sheme = drawInfo?.shema?.split('.')[0];
    // const arrayPhoto = drawInfo.like_ship.map(int =>
    //   int.photos.map(i =>
    //     drawInfo.ship_direction === 'sea'
    //       ? `https://sea.kruiz.online/assets/img/liners/liners/bergth_800x500/${i.file_name}`
    //       : `/images/cruiz_slider/ships/${int.id}/main/bergth_blogimg/${i.file_name}`,
    //   ),
    // );
    var transformedLikeShips = isSea ? drawInfo.like_ship.map(function(ship) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ship), {
            photos: ship.photos.map(function(photo) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, photo), {
                    src: "/assets/img/liners/liners/bergth_800x500/".concat(photo.src.file_name),
                    srcset: "/assets/img/liners/liners/bergth_800x500/".concat(photo.srcset.file_name)
                });
            })
        });
    }) : drawInfo.like_ship.map(function(ship) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ship), {
            photos: ship.photos.map(function(photo) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, photo), {
                    src: "/images/cruiz_slider/ships/".concat(ship.id, "/main/bergth_blogimg/").concat(photo.src.file_name),
                    srcset: "/images/cruiz_slider/ships/".concat(ship.id, "/main/bergth_blogimg/").concat(photo.srcset.file_name),
                    description: photo.src.description
                });
            })
        });
    });
    var headerHeight = isMobile ? 124 : 148;
    var scrollTo = (0,scrollToUtil/* scrollToUtil */.R)(headerHeight);
    var elRef = (0,react.useRef)();
    var servicesRef = (0,react.useRef)();
    var badgeReviewsRef = (0,react.useRef)();
    var badgeClassRef = (0,react.useRef)();
    var pageRoute = [
        {
            title: "Поиск теплоходов",
            link: "https://kruiz.online/ships"
        },
        {
            title: "".concat(shipType(shipsInfoTitle, "isTitle"), " ").concat(drawInfo.t_title),
            link: ""
        }, 
    ];
    var seaPageRoute = [
        {
            title: "Поиск лайнеров",
            link: "https://kruiz.online/ships"
        },
        {
            title: "".concat(shipType(shipsInfoTitle, "isTitle"), " ").concat(drawInfo.t_title),
            link: ""
        }, 
    ];
    var ref1 = (0,react.useState)((cookies === null || cookies === void 0 ? void 0 : cookies.closeBanner) !== undefined || (cookies === null || cookies === void 0 ? void 0 : cookies.closeBanner) === "false"), closeBanners = ref1[0], setCloseBanners = ref1[1];
    var currentDate = dayjs_min_default()();
    var timeToCookie = currentDate.add(1, "h");
    (0,dist.setCookie)(null, "closeBanner", "false");
    var openBanner = function() {
        setCloseBanners(false);
        (0,dist.setCookie)(null, "closeBanner", "false");
    };
    (0,useHiddenWithCookie/* useHiddenWithCookie */._)(openBanner);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStoreProvider/* SearchStoreProvider */.YG, {
        hydrationData: {
            user: user,
            drawInfo: drawInfo
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStoreProvider/* RootStoreProvider */.LD, {
            hydrationData: {
                user: user,
                drawInfo: drawInfo,
                discounts: drawInfo.discounts
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    title: (seo === null || seo === void 0 ? void 0 : seo.seo_title) ? seo.seo_title : seoDataTitle,
                    description: (seo === null || seo === void 0 ? void 0 : seo.description) ? seo === null || seo === void 0 ? void 0 : seo.description : seoDataDesc,
                    additionalLinkTags: [
                        {
                            rel: "shortcut icon",
                            href: "/favicon.ico?v=2"
                        }, 
                    ],
                    canonical: canonicalUrl
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
                    isMobile: isMobile,
                    isTablet: isTablet,
                    shipsSea: isSea,
                    isSea: isSea,
                    showTopContent: !closeBanners,
                    popularPopdirs: popularPopdirs,
                    topContent: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerTop, {
                            isOpen: closeBanners,
                            onOpen: setCloseBanners,
                            timeToCookie: timeToCookie,
                            isMobile: isMobile,
                            isTablet: isTablet
                        })
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container--block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* BreadCrumbs */.b, {
                                            routeCrumbs: isSea ? seaPageRoute : pageRoute
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shipPage_module_default()).header,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: (shipPage_module_default()).textWrapper,
                                            children: (seo === null || seo === void 0 ? void 0 : seo.h1) || "".concat(shipType(shipsInfoTitle, "isTitle"), " ").concat(drawInfo.t_title)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shipPage_module_default()).allContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (shipPage_module_default()).imageShip,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (shipPage_module_default()).topBar,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (shipPage_module_default()).badgeContent,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (shipPage_module_default()).badgeItemClass,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                        view: "text",
                                                                        onClick: function() {
                                                                            scrollTo(servicesRef);
                                                                            (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_rate_ships");
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                                            view: classCategoryReady,
                                                                            icon: classCategoryReady,
                                                                            size: isMobile ? "sm" : "md",
                                                                            children: drawInfo.category_name
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (shipPage_module_default()).badgeItemClass,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                        view: "text",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                                            view: "rewies",
                                                                            size: isMobile ? "sm" : "md",
                                                                            icon: "desc",
                                                                            onClick: function() {
                                                                                return (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_count_deck");
                                                                            },
                                                                            children: "".concat(drawInfo.deck_count, " ").concat((0,declOfNum/* declOfNum */.A)(drawInfo.deck_count, [
                                                                                "палуба",
                                                                                "палубы",
                                                                                "палуб"
                                                                            ]))
                                                                        })
                                                                    })
                                                                }),
                                                                drawInfo.review.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (shipPage_module_default()).badgeItemClass,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                        view: "text",
                                                                        onClick: function() {
                                                                            return scrollTo(badgeReviewsRef);
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                                            view: "shipRewievs",
                                                                            icon: "reviews",
                                                                            size: isMobile ? "sm" : "md",
                                                                            children: "".concat(drawInfo.review_count_max, "\n                              ").concat((0,declOfNum/* declOfNum */.A)(drawInfo.review_count_max, [
                                                                                "отзыв",
                                                                                "отзыва",
                                                                                "отзывов", 
                                                                            ]))
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (shipPage_module_default()).galerey,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainGallery/* MainGallery */.k, {
                                                            ship_id: drawInfo.id,
                                                            reviews: drawInfo.review,
                                                            maxi: drawInfo.ship_fotos.maxi,
                                                            mini: drawInfo.ship_fotos.mini,
                                                            isMobile: isMobile,
                                                            category: {
                                                                name: drawInfo.category_name,
                                                                type: classCategoryReady
                                                            },
                                                            title: drawInfo.t_title,
                                                            isSea: drawInfo.ship_direction === "sea" && true,
                                                            shipPage: true,
                                                            onArrowNext: function() {
                                                                return (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_next_photo_in_modal_photo");
                                                            },
                                                            onArrowPrev: function() {
                                                                return (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_previous_photo_in_modal_photo");
                                                            },
                                                            onImgClick: function() {
                                                                return (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_photo_in_modal_photo");
                                                            },
                                                            onClickMore: function() {
                                                                return (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_more_reviews_in_modal_photo");
                                                            },
                                                            onActionClose: function() {
                                                                return (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_close_modal_photo");
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipInfo, {
                                                            years: drawInfo.restoration_date,
                                                            caute: drawInfo.cauta_count,
                                                            seat: drawInfo.seat_of_the_ship,
                                                            description: (0,serialize/* serialize */.q)(seo.seo_content),
                                                            shipType: drawInfo.ship_direction,
                                                            shipHar: drawInfo.t_teh_xar,
                                                            construction: drawInfo.construction_date,
                                                            setClipp: setClipp,
                                                            clipp: clipp,
                                                            company: drawInfo.company,
                                                            onClickDescription: "click_open_description_ship",
                                                            shipTypeInfo: shipType(shipsInfoTitle, "isButton")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (shipPage_module_default()).facilities,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                variant: "heading-4",
                                                                component: "h2",
                                                                children: "Услуги на борту"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features/* Features */.A, {
                                                                features: drawInfo.facilities
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            minPrice !== 0 && drawCruise.cruises.cruises_data.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (shipPage_module_default()).pricePanel,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shipPage_module_default()).pricePanelTop,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricePanel/* PricePanel */.M, {
                                                        cruizDetail: shipDetails,
                                                        sea: drawInfo.ship_direction,
                                                        price: drawInfo.kr_min_price,
                                                        onChoose: function() {
                                                            return scrollTo(elRef);
                                                        },
                                                        priceDiscounted: drawInfo.kr_min_price_discounted || drawInfo.kr_min_price,
                                                        isShips: true,
                                                        elRef: badgeClassRef,
                                                        cashback: drawCruise.cashback,
                                                        ownerId: drawInfo.owner_id,
                                                        isMobile: isMobile
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        drawCruise.cruises.cruises_data.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: elRef,
                            id: "filter",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterShips/* FilterShips */.g, {
                                url: drawCruise.cruises.cruises_data[0].url,
                                compact: true,
                                values: true,
                                isMobile: isMobile,
                                sea: drawInfo.ship_direction,
                                tabs: tabsYear,
                                years: arrayYear,
                                shipType: shipType(shipsInfoTitle, "isRouter"),
                                ownerId: drawInfo.owner_id
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container container--start",
                            children: [
                                drawInfo.yandex_zen_link && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shipPage_module_default()).yandexButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YandexLink/* YandexLink */.t, {
                                        link: drawInfo.yandex_zen_link,
                                        isShip: true
                                    })
                                }),
                                drawInfo.review.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: (shipPage_module_default()).sect,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shipPage_module_default()).reviewsHeader,
                                            ref: badgeReviewsRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                variant: "heading-1",
                                                component: "h2",
                                                children: "Отзывы"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews/* Reviews */.Z, {
                                            items: drawInfo.review,
                                            isMobile: isMobile,
                                            onActionClick: "click_view_more_reviews"
                                        })
                                    ]
                                }),
                                drawInfo.like_ship.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shipPage_module_default()).shema,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            variant: "heading-4",
                                            children: "Вам так же могут понравиться"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shipPage_module_default()).cards,
                                            children: transformedLikeShips.map(function(i, id) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shipPage_module_default()).cardShips,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                                        isShipCard: true,
                                                        title: i.t_title,
                                                        category: i.category_id,
                                                        countDesc: i.deck_count,
                                                        caute_count: i.cauta_count,
                                                        seat_count: i.seat_of_the_ship,
                                                        images: i.photos,
                                                        link: i.url,
                                                        blackFriday: 0,
                                                        shipId: i.id,
                                                        isMobile: isMobile,
                                                        sea: isSea,
                                                        recomend: isSea
                                                    }, id)
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shipPage_module_default()).footerCard,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                variant: "showMore",
                                                href: isSea ? "/liners" : "/ships",
                                                onClick: function() {
                                                    (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_view_more_you_might_like");
                                                },
                                                children: "Показать ещё"
                                            })
                                        })
                                    ]
                                }),
                                (0,utils_seo/* hasSeo */.rd)(seo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    className: (shipPage_module_default()).seoTabs,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsed/* Collapsed */.H, {
                                        seo: (0,utils_seo/* seoData */.hD)(seo),
                                        shorter: true,
                                        isSeo: true
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalReload/* ModalReload */.U, {})
            ]
        })
    });
};


/***/ }),

/***/ 13553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hD": function() { return /* binding */ seoData; },
/* harmony export */   "rd": function() { return /* binding */ hasSeo; }
/* harmony export */ });
/* unused harmony exports getSeoText, hasSeoCaption, hasSeoText */
/* harmony import */ var _serialize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27777);

var getSeoText = function(seo, popdir) {
    var seoText = seo === null || seo === void 0 ? void 0 : seo.seo_text;
    var popdirText = popdir === null || popdir === void 0 ? void 0 : popdir.seo_text_b2b;
    return seoText || popdirText;
};
var seoData = function(_seo, popdir) {
    return getSeoText(_seo, popdir).map(function(item, index) {
        return {
            title: _seo.seo_text_caption[index],
            description: (0,_serialize__WEBPACK_IMPORTED_MODULE_0__/* .serialize */ .q)(item.flat(Infinity))
        };
    });
};
var hasSeoCaption = function(_seo) {
    var ref;
    return !!(_seo === null || _seo === void 0 ? void 0 : (ref = _seo.seo_text_caption) === null || ref === void 0 ? void 0 : ref.filter(Boolean).length);
};
var hasSeoText = function(_seo, popdir) {
    return !!getSeoText(_seo, popdir);
};
var hasSeo = function(_seo, popdir) {
    return hasSeoCaption(_seo) && hasSeoText(_seo, popdir);
};


/***/ }),

/***/ 27777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ serialize; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var slate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77493);
/* harmony import */ var escape_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95573);
/* harmony import */ var escape_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(escape_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49028);





var serialize = function(children) {
    return children === null || children === void 0 ? void 0 : children.map(function(node, i) {
        if (node.type === "numbered-list") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                children: serialize(node.children)
            }, i);
        }
        if (slate__WEBPACK_IMPORTED_MODULE_4__/* .Text.isText */ .xv.isText(node)) {
            var text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.text)
                }
            });
            if (node.bold) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: text
                }, i);
            }
            if (node.code) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
                    children: text
                }, i);
            }
            if (node.italic) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                    children: text
                }, i);
            }
            if (node.underline) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        textDecoration: "underline"
                    },
                    children: text
                }, i);
            }
            if (node.strikethrough) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        textDecoration: "line-through"
                    },
                    children: text
                }, i);
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: text
            }, i);
        }
        if (!node) {
            return null;
        }
        switch(node.type){
            case "h1":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: serialize(node.children)
                }, i);
            case "h2":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: serialize(node.children)
                }, i);
            case "h3":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    children: serialize(node.children)
                }, i);
            case "h4":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    children: serialize(node.children)
                }, i);
            case "h5":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    children: serialize(node.children)
                }, i);
            case "h6":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                    children: serialize(node.children)
                }, i);
            case "blockquote":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                    children: serialize(node.children)
                }, i);
            case "ul":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: serialize(node.children)
                }, i);
            case "ol":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    children: serialize(node.children)
                }, i);
            case "li":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: serialize(node.children)
                }, i);
            case "list-item":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: serialize(node.children)
                }, i);
            case "heading-one":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: serialize(node.children)
                }, i);
            case "heading-two":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: serialize(node.children)
                }, i);
            case "link":
                if (node.url.includes("youtube.com") || node.url.includes("https://vk.com/video")) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            height: "420px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                            width: "100%",
                            title: "YouTube video player",
                            src: node.url,
                            allowFullScreen: true,
                            allow: "accelerometer",
                            referrerPolicy: "strict-origin-when-cross-origin"
                        })
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    rel: "noopener noreferrer",
                    style: {
                        color: "blue"
                    },
                    children: serialize(node.children)
                }, i);
            case "image":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image_Image__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
                    src: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    srcSet: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    alt: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.alt),
                    title: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.title),
                    loading: "lazy",
                    itemProp: "image"
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: serialize(node.children)
                }, i);
        }
    });
};


/***/ }),

/***/ 38264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__Ww9nJ","accordionTitle":"accordion_accordionTitle__M2XG2","innerTitle":"accordion_innerTitle__wJIwd","accordionContent":"accordion_accordionContent__pVsW5","accordionContentActive":"accordion_accordionContentActive__Lnz13","close":"accordion_close__jwAf8","open":"accordion_open__FTLja"};

/***/ }),

/***/ 16886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__Khlbh","avatarImg":"avatar_avatarImg__b7gUj"};

/***/ }),

/***/ 63643:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"comment_wrapper__Vbloe","buttonClipper":"comment_buttonClipper__wGDg6","star":"comment_star__ZqWTb","allInfo":"comment_allInfo__M75JD","excClipper":"comment_excClipper__aeJP2","info":"comment_info__9WxUs","avatar":"comment_avatar__wQRMf","link":"comment_link__A7WfX","user":"comment_user__VyeDY","rating":"comment_rating__1m3wk","img":"comment_img__ei3z0","imgAll":"comment_imgAll__Xl3MV"};

/***/ }),

/***/ 99407:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"arrows_btn__MpugV","emblaButton":"arrows_emblaButton__jYhAy","emblaButtonPrev":"arrows_emblaButtonPrev__LLGM1","emblaButtonNext":"arrows_emblaButtonNext__c6yBu","lg":"arrows_lg__q8ytc"};

/***/ }),

/***/ 69907:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"reviews_infoWrapper__Gz_80","info":"reviews_info__tuce9","button":"reviews_button___jir0"};

/***/ }),

/***/ 51505:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonBack":"shipPage_buttonBack__GJ7Rz","textWrapper":"shipPage_textWrapper__OMsem","yandexButton":"shipPage_yandexButton__V0Mrn","seoTabs":"shipPage_seoTabs__f5_Cm","innerAside":"shipPage_innerAside__IIy8s","topBar":"shipPage_topBar__wEc0T","badgeContent":"shipPage_badgeContent__FR1Kq","shipDesc":"shipPage_shipDesc__dklWM","galerey":"shipPage_galerey__hIlAh","showMore":"shipPage_showMore__Owzkl","footerCard":"shipPage_footerCard__mGVj_","restavration":"shipPage_restavration__wSbHm","restavrationText":"shipPage_restavrationText__cl58W","cards":"shipPage_cards__od6Xl","img":"shipPage_img___YBnT","cardShips":"shipPage_cardShips__S4cp4","reviewsHeader":"shipPage_reviewsHeader__Km5RX","pricePanel":"shipPage_pricePanel__K3gVJ","pricePanelTop":"shipPage_pricePanelTop__jp6qm","shema":"shipPage_shema__cTtw8","shemaText":"shipPage_shemaText__IoDIW","allContent":"shipPage_allContent__cTFh0","aside":"shipPage_aside__Q_z2T","specification":"shipPage_specification__6_pP0","company":"shipPage_company__ZKjTq","header":"shipPage_header__JpLNV","specifications":"shipPage_specifications__bA9R5","specificationsOne":"shipPage_specificationsOne__44DnD","specificationsOneInside":"shipPage_specificationsOneInside__biu2o","cruises":"shipPage_cruises__ulDq2","cruisesFooter":"shipPage_cruisesFooter__THuKl","cruisesHeader":"shipPage_cruisesHeader__H_crA","cruisesInfo":"shipPage_cruisesInfo__bDD18","cruisesInfoRight":"shipPage_cruisesInfoRight__bONHE","cruisesInfoRightButton":"shipPage_cruisesInfoRightButton__F4cMt","cruisesInfoRoute":"shipPage_cruisesInfoRoute__RK0Cz","cruisesInfoData":"shipPage_cruisesInfoData__grlVD","cruisesInfoDataRight":"shipPage_cruisesInfoDataRight__j4kPQ","cruisesInfoPrice":"shipPage_cruisesInfoPrice__0_7QF","cruisesInfoPriceOld":"shipPage_cruisesInfoPriceOld__5zBRS","cruisesInfoPriceNew":"shipPage_cruisesInfoPriceNew__zqOgT","countInfo":"shipPage_countInfo__Eazws","countInfoText":"shipPage_countInfoText___g_rk","sect":"shipPage_sect__I6Wr0","crumbs":"shipPage_crumbs__dMs4t"};

/***/ }),

/***/ 81341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getClosestBody */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _misc_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76362);


function getClosestBody(el) {
    if (!el) {
        return null;
    }
    else if (el.tagName === 'BODY') {
        return el;
    }
    else if (el.tagName === 'IFRAME') {
        var document_1 = el.contentDocument;
        return document_1 ? document_1.body : null;
    }
    else if (!el.offsetParent) {
        return null;
    }
    return getClosestBody(el.offsetParent);
}
function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1)
        return true;
    if (e.preventDefault)
        e.preventDefault();
    return false;
}
var isIosDevice = _misc_util__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU &&
    window.navigator &&
    window.navigator.platform &&
    /iP(ad|hone|od)/.test(window.navigator.platform);
var bodies = new Map();
var doc = typeof document === 'object' ? document : undefined;
var documentListenerAdded = false;
/* harmony default export */ __webpack_exports__["Z"] = (!doc
    ? function useLockBodyMock(_locked, _elementRef) {
        if (_locked === void 0) { _locked = true; }
    }
    : function useLockBody(locked, elementRef) {
        if (locked === void 0) { locked = true; }
        var bodyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(doc.body);
        elementRef = elementRef || bodyRef;
        var lock = function (body) {
            var bodyInfo = bodies.get(body);
            if (!bodyInfo) {
                bodies.set(body, { counter: 1, initialOverflow: body.style.overflow });
                if (isIosDevice) {
                    if (!documentListenerAdded) {
                        (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__.on)(document, 'touchmove', preventDefault, { passive: false });
                        documentListenerAdded = true;
                    }
                }
                else {
                    body.style.overflow = 'hidden';
                }
            }
            else {
                bodies.set(body, {
                    counter: bodyInfo.counter + 1,
                    initialOverflow: bodyInfo.initialOverflow,
                });
            }
        };
        var unlock = function (body) {
            var bodyInfo = bodies.get(body);
            if (bodyInfo) {
                if (bodyInfo.counter === 1) {
                    bodies.delete(body);
                    if (isIosDevice) {
                        body.ontouchmove = null;
                        if (documentListenerAdded) {
                            (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__/* .off */ .S1)(document, 'touchmove', preventDefault);
                            documentListenerAdded = false;
                        }
                    }
                    else {
                        body.style.overflow = bodyInfo.initialOverflow;
                    }
                }
                else {
                    bodies.set(body, {
                        counter: bodyInfo.counter - 1,
                        initialOverflow: bodyInfo.initialOverflow,
                    });
                }
            }
        };
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
            var body = getClosestBody(elementRef.current);
            if (!body) {
                return;
            }
            if (locked) {
                lock(body);
            }
            else {
                unlock(body);
            }
        }, [locked, elementRef.current]);
        // clean up, on un-mount
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
            var body = getClosestBody(elementRef.current);
            if (!body) {
                return;
            }
            return function () {
                unlock(body);
            };
        }, []);
    });


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1272,3336,718,3108,7499,889,5082,3215,5395,5541,9774,2888,179], function() { return __webpack_exec__(77909); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);